// src/services/paymentService.js
import api from '../api';

/**
 * Service for handling payment interactions with the backend
 */
export const paymentService = {
  /**
   * Create a Stripe checkout session
   * @param {Object} paymentData - Payment data including type, success and cancel URLs
   * @param {string} paymentData.paymentType - Type of payment (e.g. 'NEGOTIATION', 'STAFFING')
   * @param {string} paymentData.successUrl - URL to redirect to after successful payment
   * @param {string} paymentData.cancelUrl - URL to redirect to when payment is canceled
   * @param {string} [paymentData.customerEmail] - Optional customer email for payment receipt
   * @returns {Promise<{id: string}>} - The Stripe checkout session
   */
  createCheckoutSession: async (paymentData) => {
    const response = await api.post('/payment/create-checkout-session', paymentData);
    return response.data;
  },

  /**
   * Create a Stripe checkout session for a qualified lead payment
   * @param {string} matchId - ID of the match for which payment is made
   * @returns {Promise<{sessionId: string}>}
   */
  createLeadCheckoutSession: async (matchId) => {
    const response = await api.post('/payment/create-lead-checkout-session', { matchId });
    return response.data;
  }
};

export default paymentService;
